module.exports = "pegasus/assets/themelp1/large/60.png";